import { render, staticRenderFns } from "./publicationActivity.vue?vue&type=template&id=5f14c9fb&scoped=true"
import script from "./publicationActivity.vue?vue&type=script&lang=js"
export * from "./publicationActivity.vue?vue&type=script&lang=js"
import style0 from "./publicationActivity.vue?vue&type=style&index=0&id=5f14c9fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14c9fb",
  null
  
)

export default component.exports